// Recently-viewed teams, persisted in localStorage (per browser, no backend).
// PageLayout records a snapshot whenever a team page loads; SearchPage shows
// the list (GameChanger-style) until the user types a query.

export interface RecentTeam {
  id: string;
  name: string;
  sport?: string;
  seasonName?: string;
  seasonYear?: string | number;
  city?: string;
  state?: string;
  staff?: string[] | string;
  viewedAt: number;
}

const KEY = "gc-stats:recently-viewed";
const MAX_ENTRIES = 8;

export const getRecentlyViewed = (): RecentTeam[] => {
  try {
    const raw = window.localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const save = (teams: RecentTeam[]) => {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(teams));
  } catch {
    // Storage full or unavailable — recently-viewed is best-effort.
  }
};

export const addRecentlyViewed = (team: Omit<RecentTeam, "viewedAt">) => {
  if (!team.id || !team.name) return;
  const rest = getRecentlyViewed().filter((entry) => entry.id !== team.id);
  save([{ ...team, viewedAt: Date.now() }, ...rest].slice(0, MAX_ENTRIES));
};

export const removeRecentlyViewed = (id: string): RecentTeam[] => {
  const rest = getRecentlyViewed().filter((entry) => entry.id !== id);
  save(rest);
  return rest;
};

export const clearRecentlyViewed = (): RecentTeam[] => {
  save([]);
  return [];
};
